<script setup lang="ts">
import { ref } from 'vue'
import { useAppState } from '../stores/AppState'
import IconAccessLogo from './icons/IconAccessLogo.vue'
const appState = useAppState()

const drawer = ref(false)
const mobileNavigationFilteredFeatures = ref(
  appState.$state.discovery?.features
    .filter((f) => f.componentName !== null && f.permission === 'HasAccess')
    .slice(0, 3) // Only show the first 3 features in the bottom navigation
)
</script>
<template>
  <v-bottom-navigation elevation="3" grow class="bottom-nav">
    <v-btn to="/">
      <v-icon :icon="IconAccessLogo"> </v-icon>
      <div class="d-inline-block text-truncate content-width">Home</div>
    </v-btn>
    <template v-for="(feature, index) in mobileNavigationFilteredFeatures" :key="index">
      <v-btn :to="feature.defaultPath">
        <v-icon>{{ feature.materialDesignIconName }}</v-icon>
        <div class="d-inline-block text-truncate content-width">
          {{ feature.name }}
        </div>
      </v-btn>
    </template>
    <v-btn @click.stop="drawer = !drawer">
      <v-icon>mdi-dots-horizontal</v-icon>
      <div class="d-inline-block text-truncate content-width">More</div>
    </v-btn>
  </v-bottom-navigation>
  <v-navigation-drawer v-model="drawer" location="right" temporary style="border: 0px">
    <v-divider thickness="10" class="v-divider-accent border-opacity-100 w-100"></v-divider>
    <v-list-item
      v-for="(feature, index) in appState.$state.discovery?.features.filter(
        (f) =>
          f.componentName !== null &&
          f.permission === 'HasAccess' &&
          !mobileNavigationFilteredFeatures?.includes(f)
      )"
      class="drawer-items"
      :key="index"
      :to="feature.defaultPath"
      :prepend-icon="feature.materialDesignIconName"
    >
      <div class="d-inline-block text-truncate" style="width: 100% !important">
        {{ feature.name }}
      </div>
    </v-list-item>
  </v-navigation-drawer>
  <v-overlay v-model="drawer" z-index="10"></v-overlay>
</template>
<style scoped>
/* Remove the overlay on the buttons in the bottom navigation when one of them is selected*/
:deep(.v-btn__overlay) {
  opacity: 0 !important;
}

.drawer-items {
  padding: 0.5rem;
  margin: 0.5rem;
}

.bottom-nav {
  display: flex;
  flex: 1 !important;
  justify-content: space-around;
  text-align: center !important;
  align-items: center;
}

/* Buttons in Bottom Navigation  */
.bottom-nav .v-btn {
  padding-left: 0.05vw !important;
  padding-right: 0.05vw !important;
  /* override the default width */
  max-width: 19vw !important;
  min-width: 19vw !important;
}
.content-width {
  width: 19vw !important;
}
</style>
